<template>
  <div v-if="$store.state.is_manager">
    <div class="select-container clearfix" style="margin-top: 6%;margin-left: 33%;float: center;">
      <el-form ref="form"  label-width="80px">
        <el-form-item label="基础文档">
          <el-cascader ref="cascader" change-on-select :options="form.options" clearable v-model="basePage"></el-cascader>
        </el-form-item>

        <el-form-item label="映射文档">
          <el-cascader ref="cascader" change-on-select :options="form.options" clearable v-model="relaPage"></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="checkSubmit">提交</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "addLangIndex",
  mounted: function () {
    var vm = this;
    if (!(vm.$store.state.is_manager)) {
      this.$notify({
        title: '没有权限',
        message: '你没有操作当前菜单的权限',
        type: 'error'
      });
      return;
    }
    if (vm.token == "") {
      var token = vm.getCookie("access-token");
      if (token != null) {
        vm.$store.commit('UPDATETOKEN', token);
        vm.token = token;
      }
    }
    this.$nextTick(() => {
      // 请求新增的目录
      axios.get(vm.selectItemList, {
        withCredentials: true
      }).then((response) => {
        if (response.data && response.data.status === 401) {
          window.location = vm.loginRediret;
          return;
        }
        let itemList = response.data.data;
        if (!itemList || itemList.length === 0) {
          return;
        }
        vm.$set(vm.form, 'options', itemList);
      }).catch(function (error) {
        vm.requesterrorinfo(error)
      })
    });
  },
  computed: mapState({
    selectItemList: function (state) {
      return state.selectItemList;
    },
    addLangRelation: function (state) {
      return state.addLangRelation;
    },
    checkLangRelation: function (state) {
      return state.checkLangRelation;
    },
  }),
  data() {
    return {
      form: {
        options: [],
      },
      value: '',
      token: '',
      basePage:[],
      relaPage:[]
    }
  },
  methods: {
    getCookie(name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
      else
        return null;
    },
    async checkSubmit() {
      var vm = this;
      var baseLength = vm.basePage.length;
      var relaLength = vm.relaPage.length;
      if (baseLength == 0 || relaLength == 0) {
        this.$message.error('请选择要关联的文档!');
        return;
      } else {
        let index = vm.basePage[vm.basePage.length - 1];
        let relaIndex = vm.relaPage[vm.relaPage.length - 1];
        await axios.post(vm.checkLangRelation, {index: index, relaIndex: relaIndex}, {
          withCredentials: true
        }).then((response) => {
          if (response.data.code == 0) {
            this.$confirm('此操作会覆盖已有映射关系，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.onSubmit();
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          } else if (response.data.code == 1) {
            this.onSubmit();
          } else {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          this.requesterrorinfo(error)
        })

      }
    },
    async onSubmit() {
      var vm = this;
      var baseLength = vm.basePage.length;
      var relaLength = vm.relaPage.length;
      if (baseLength == 0 || relaLength == 0) {
        this.$message.error('请选择要关联的文档!');
        return;
      } else {
        let index = vm.basePage[vm.basePage.length - 1];

        let relaIndex = vm.relaPage[vm.relaPage.length - 1];

        await axios.post(vm.addLangRelation, {index: index, relaIndex: relaIndex}, {
          withCredentials: true
        }).then((response) => {
         if (response.data.code == 0) {
            this.$message.success('映射信息更新成功');
            return;
          } else {
            this.$message.error(response.data.message);
            return;
          }
        }).catch(function (error) {
          this.requesterrorinfo(error)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// addLangIndex.vue?37930ffc